<template>
     <div>
        <h1 style='text-align:center'>{{ settingObj.name }} : Préférences</h1>

        <div id="prefTab" class="pl-list">
            <div class="header">
                <div class="header_line">
                    <div id="header_col1" class="header_col col1">Préférences [ProLexis]</div>
                </div>
            </div>
        
            <div class="content" ref="prefsBox">
                <div class='line' v-if="showPLLine()" >
                    <div class="col col1" >Préférences [ProLexis]</div>
                    <div class="col col2">
                        <label id='btn_upload_pl' class="liste_btn " for="upload_pl">Sélectionner un fichier</label>
                        <input id='upload_pl' name='upload_pl' class="input_upload" type="file" :title="btnPLTitle != '' ? btnPLTitle :'Sélectionner la charte'" @change="handlePLPrefFileUpload( $event )" />
                        <div  id='txt_upload_pl'  :class="isBtnPLDisabled && btnPLTitle != '' ? 'red' : ''">{{ plPrefsFile != noFile && plPrefsFile != undefined ? plPrefsFile.name : noFile }}</div>

                        <span v-if="isBtnPLDisabled && btnPLTitle != ''" class="material-icons icn_errorfile" title="Erreur, nom du fichier incorrect" @click='cleanPLFile()'>error_outline</span>
                        <span v-if="!isBtnPLDisabled && plPrefsFile != noFile" class="material-icons icn_okfile" title="Ok">check</span>
                    </div>

                    <button id="btnExport_pl" title="Télécharger" class="mdl-button mdl-js-button mdl-button--icon" @click='downloadPL()'><i class="material-icons">file_download</i></button>
                </div>
                <div class='line' v-if="showMYRLine()" >
                    <div :class="'col col1 ' + (!hasMyrPref() ? 'red' : '')" >Préférences [Myriade]</div>
                    <div class="col col2" v-if="isSuperAdmin()">
                        <label id='btn_upload_myr' class="liste_btn " for="upload_myr">Sélectionner un fichier</label>
                        <input id='upload_myr' name='upload_myr' class="input_upload" type="file" :title="btnMYRTitle != '' ? btnMYRTitle :'Sélectionner la charte'" @change="handleMYRPrefFileUpload( $event )" />
                        <div  id='txt_upload_myr'  :class="isBtnMYRDisabled && btnMYRTitle != '' ? 'red' : ''">{{ myrPrefsFile != noFile && myrPrefsFile != undefined ? myrPrefsFile.name : noFile }}</div>

                        <span v-if="isBtnMYRDisabled && btnMYRTitle != ''" class="material-icons icn_errorfile" title="Erreur, nom du fichier incorrect" @click='cleanMYRFile()'>error_outline</span>
                        <span v-if="!isBtnMYRDisabled && myrPrefsFile != noFile" class="material-icons icn_okfile" title="Ok">check</span>
                    </div>
                    <div class="col col2" v-else >
                        <span class="support">Pour Myriade, merci de contacter le support.</span>
                    </div>


                    <button v-if="isSuperAdmin() && hasMyrPref()" id="btnDelete_myr" class="mdl-button mdl-js-button mdl-button--icon btn_deletesub" :title="'Supprimer les prefs Myriade'" @click='askDeletePrefsMyr()'><i class="material-icons">delete</i></button>
                    <button v-if="hasMyrPref()" id="btnExport_myr" title="Télécharger" class="mdl-button mdl-js-button mdl-button--icon" @click='downloadMYR()' ><i class="material-icons">file_download</i></button>
                </div>


                <div class="dummyline" :style="{'height': dummyPreferenceHeight+'px'}">
                    <div class="col col1">&nbsp;</div>
                </div>
            </div>
            <div class="footer">
                <div class="buttons">
                    <button id="btnSubmit"  type="button" class="liste_btn boutonTableau" :title="btnSubmitTitle" @click="submitFiles()" :disabled="isSubmitDisabled()" >Déposer</button>
                </div>
            </div>
        </div>
        <div class="infodl">
            <div class="txt_infodl">Si vous avez modifié vos préférences de ProLexis depuis votre client lourd et que vous souhaitez reporter ces modifications sur votre configuration ProLexis WebService, vous pouvez les déposer directement ci-dessus. <u>Attention, le nom doit être conservé.</u></div>
        </div>
        <br/>
        <div id="warning">
            <i id="warning_icon" class="material-icons">warning_amber</i>
            <span id="warning_txt"> Tout changement dans cette page sera effectif <u>15 minutes</u> après avoir cliqué sur "Envoyer les modifs" en haut à droite.</span>
        </div>
    </div>
</template>

<script>
    import { diagonalbackURL, defaultConfig, OctetStreamConfig, FormDataConfig } from "../constantes";
    import axios from 'axios'
    import { RoleEnum } from '../classes/enums'
    import FctUtils from '@/components/FctUtils';

    export default {
        name: "Preferences",
        mixins: [FctUtils],
        props:{
            settingProps: {type:String}, // arrive depuis un push -> String
        },
        data() {
            return {
                PLName:"Préférences [ProLexis]",
                MYRName:"Préférences [Myriade]",
                noFile:"Aucun fichier choisi",
                //
                settingObj: {},
                preferences: {},
                // Preference PL
                prefPL:{},
                plPrefsFile: this.noFile,
                isBtnPLDisabled:true,
                btnPLTitle:'',
                // Preference MYR
                prefMYR:{},
                myrPrefsFile: this.noFile,
                isBtnMYRDisabled:true,
                btnMYRTitle:'',
                //
                btnSubmitTitle:'',
                dummyPreferenceHeight:25,
            }
        },
        created() {
            // Init var specifique du fichier
            this.plPrefsFile  = this.noFile;
            this.myrPrefsFile = this.noFile;

            // Si pas de settings, on regarde s'il n'y en a pas un deja dans le store
            if (!FctUtils.methods.noEmpty(this.settingProps)) {
                this.settingObj = this.$store.getters.setting;
            }
            else {
                this.settingObj = JSON.parse(this.settingProps);
            }

            // Si Setting Ok, on affiche les preferences correspondantes
            if (FctUtils.methods.noEmpty(this.settingObj)) {

                axios.get(diagonalbackURL + "/settings/"+ this.settingObj.id +"/preferences", defaultConfig)
                .then(reponse => {
                    this.preferences = reponse.data;

                    for (var i in this.preferences) {
                        if (this.preferences[i].name == 'prolexis') {
                            this.prefPL = this.preferences[i];
                        }
                        else if (this.preferences[i].name == 'myriade') {
                            this.prefMYR = this.preferences[i];
                        }
                    }

                })
                .catch(error => this.errorHandler(error));

            }
            else {
                // si toujours pas de setting, on retourne vers la selection de la configuration
                this.$router.push({name:"SelectDicoSetting", params: {
                    from: "Preferences"
                } })
            }
        },
        mounted() {
            this.calcDummyPreferenceHeight();

            // On ne peux supprimer que les prefs de Myriade
            this.emitter.on('removePrefs', aPrefsToDelData => {
                this.removePrefsMYR(aPrefsToDelData)
            });
        },
        unmounted() {
            this.emitter.off('removePrefs');
        },
        computed : {
            prefUser: function(){
                return this.$store.state.currentUser;
            },
            prefUserInfo: function(){
                return this.$store.state.currentTokenInfo;
            },
        },
        methods : {
            isSuperAdmin(){
                return this.$store.state.currentUser.role == RoleEnum.SUPERADMIN.value;
            },
            showPLLine() {
                return Object.keys(this.prefPL).length != 0;
            },
            handlePLPrefFileUpload(event){
                this.plPrefsFile = event.target.files[0];

                this.isBtnPLDisabled = true;
                this.btnPLTitle = '';

                if (this.plPrefsFile.name.normalize('NFC') == this.PLName.normalize('NFC')) {
                    this.isBtnPLDisabled = false;
                }

                if (this.isBtnPLDisabled) {
                    this.btnPLTitle = 'Fichier incompatible, contacter votre administrateur';
                }
            },
            cleanPLFile() {
                document.getElementById('upload_pl').value = '';
                this.plPrefsFile = this.noFile;
                this.isBtnPLDisabled = true;
                this.btnPLTitle = '';
            },
            downloadPL() {
                var url = diagonalbackURL + "/settings/"+ this.settingObj.id + "/preferences/prolexis";

                axios(url, OctetStreamConfig)
                .then(response => {
                    this.downloadFile(this.PLName, response.data);
                })
                .catch(async error => {
                    const errorCatched = await FctUtils.methods.areSettingsLocked(error);

                    if (errorCatched) {
                        this.emitter.emit('showPopup', {mode: 'error_maj'});
                    }
                    this.errorHandler(error)
                });
            },
            uploadPlPrefs(aPLPrefsData) {
                console.log("Creation de la charte : " + this.plPrefsFile.name)
                var self = this;

                //var filename = encodeURIComponent(this.charteFile.name);

                // Initialize the form data
                let formData = new FormData();

                // Add the form data we need to submit
                formData.append('file', this.plPrefsFile);

                var url = encodeURI(diagonalbackURL + "/settings/"+this.settingObj.id+"/preferences/prolexis");

                axios.put(url, formData, FormDataConfig)
                .then(reponse => {
                    self.plPrefsFile = '';
                    this.$store.dispatch('changeCompteur', this.$store.getters.compteur+1);
                    this.$router.go();
                })
                .catch(error => this.errorHandler(error));
            },
            //////////////
            hasMyrPref() {
                return Object.keys(this.prefMYR).length != 0;
            },
            showMYRLine() {
                return this.isSuperAdmin() || this.hasMyrPref();
            },
            handleMYRPrefFileUpload(event){
                this.myrPrefsFile = event.target.files[0];

                this.isBtnMYRDisabled = true;
                this.btnMYRTitle = '';

                if (this.myrPrefsFile.name.normalize('NFC') == this.MYRName.normalize('NFC')) {
                    this.isBtnMYRDisabled = false;
                }

                if (this.isBtnMYRDisabled) {
                    this.btnMYRTitle = 'Fichier incompatible, contacter votre administrateur';
                }
            },
            cleanMYRFile() {
                document.getElementById('upload_myr').value = '';
                this.myrPrefsFile = this.noFile;
                this.isBtnMYRDisabled = true;
                this.btnMYRTitle = '';
            },
            downloadMYR() {
                var url = diagonalbackURL + "/settings/"+ this.settingObj.id + "/preferences/myriade";

                axios(url, OctetStreamConfig)
                .then(response => {
                    this.downloadFile(this.MYRName, response.data);
                })
                .catch(async error => {
                    const errorCatched = await FctUtils.methods.areSettingsLocked(error);

                    if (errorCatched) {
                        this.emitter.emit('showPopup', {mode: 'error_maj'});
                    }
                    this.errorHandler(error)
                });
            },
            askDeletePrefsMyr() {
                this.emitter.emit('showPLForm', {mode:'formPrefs_remove', data:this.MYRName});
            },
            removePrefsMYR(aPrefsToDelData) {
                console.log("Suppression des préférences de Myriade")

                var url = encodeURI(diagonalbackURL + "/settings/"+this.settingObj.id+"/preferences/myriade");

                axios.delete(url, defaultConfig)
                .then(reponse => {
                     if((reponse.status == '400')) {
                        alert('Echec lors de la suppression des préférences de Myriade');
                    }
                    else {
                        //alert('Suppression du dictionnaire : ' + toDelCharte.name);
                        this.$store.dispatch('changeCompteur', this.$store.getters.compteur+1);
                        this.$router.go();
                    }
                })
                .catch(error => this.errorHandler(error));
            },
            ///////////////////////////////////////////////
            isSubmitDisabled() {
                var result = true; // le btn est disabled
                var title  = 0;

                // Est ce qu'un fichier est correctement choisi ? 
                if ( (this.plPrefsFile != this.noFile && !this.isBtnPLDisabled)) { // Pour PL 
                    result = false;
                    title += 1;
                }
                if ( (this.myrPrefsFile != this.noFile && !this.isBtnMYRDisabled)) { // Pour MYR
                    result = false;
                    title += 10;
                }

                // Si un fichier est MAL choisi, on grise le soumettre
                if ( (this.plPrefsFile != this.noFile && this.isBtnPLDisabled)) { // pour PL
                    result = true;
                    title += 100;
                }
                if ( (this.myrPrefsFile != this.noFile && this.isBtnMYRDisabled)) { // pour MYR
                    result = true;
                    title += 1000;
                }

                // C'est pas super joli mais au moins, c'est exhaustif
                if (title == 0) this.btnSubmitTitle = "Veuillez sélectionner des préférences à soumettre";
                else if (title == 1) this.btnSubmitTitle = "Les préférences de Prolexis sont prêtes à être soumises";
                else if (title == 10) this.btnSubmitTitle = "Les préférences de Myriade sont prêtes à être soumises";
                else if (title == 11) this.btnSubmitTitle = "Les 2 préférences sont prêtes à être soumises";
                else if (title == 1100) this.btnSubmitTitle = "Les 2 fichiers sont incorrect";
                else if (title >= 1000) this.btnSubmitTitle = "Le fichier de Myriade est incorrect";
                else if (title >= 100)  this.btnSubmitTitle = "Le fichier de Prolexis est incorrect";
                
                return result;
            },
            // Envoyer LES fichiers au serveur
            submitFiles() {
                console.log("Envoi des préférences");
                var self = this;

                // Envoi des preferences de Prolexis si fichier présent 
                if (this.plPrefsFile != this.noFile) {
                    // Initialize the form data
                    let formData = new FormData();

                    // Add the form data we need to submit
                    formData.append('file', this.plPrefsFile);

                    var url = encodeURI(diagonalbackURL + "/settings/"+this.settingObj.id+"/preferences/prolexis");

                    axios.put(url, formData, FormDataConfig)
                    .then(reponse => {
                        self.plPrefsFile = self.noFile;
                        this.$store.dispatch('changeCompteur', this.$store.getters.compteur+1);
                        this.$router.go();
                    })
                    .catch(async error => {
                        const errorCatched = await FctUtils.methods.areSettingsLocked(error);

                        if (errorCatched) {
                            this.emitter.emit('showPopup', {mode: 'error_maj'});
                        }
                        else {
                            FctUtils.methods.errorHandler(error); 
                            this.emitter.emit('showPopup', {mode: 'error_refresh'});
                        }
				    });
                }

                // Envoi des preferences de Myriade si fichier présent 
                if (this.myrPrefsFile != this.noFile) {
                    // Initialize the form data
                    let formData = new FormData();

                    // Add the form data we need to submit
                    formData.append('file', this.myrPrefsFile);

                    var url = encodeURI(diagonalbackURL + "/settings/"+this.settingObj.id+"/preferences/myriade");

                    axios.put(url, formData, FormDataConfig)
                    .then(reponse => {
                        self.myrPrefsFile = self.noFile;
                        this.$store.dispatch('changeCompteur', this.$store.getters.compteur+1);
                        this.$router.go();
                    })
                    .catch(error => this.errorHandler(error));
                }
            },
            //////////////////////////
            calcDummyPreferenceHeight() {
                var calcHeight = 25;
                if (this.$refs.prefsBox != undefined ) {
                    calcHeight = this.$refs.prefsBox.scrollHeight - (1*26); // 1 seul ligne pour l'instant ici
                }

                this.dummyPreferenceHeight = calcHeight;
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#prefTab .line {
    width: 100%;
    position: relative;
}

#prefTab .col2 {
    width: auto;
}


#btnImport {
    position: absolute;
    top: 5px;
    right: 25px;
    color: #0075bb;
}

#btnExport_pl, #btnExport_myr {
    position: absolute;
    top: 5px;
    right: 5px;
    color: #0075bb;
}

#btnDelete_pl, #btnDelete_myr {
    position: absolute;
    top: 5px;
    right: 25px;
    color: #cc0b00;
}


#upload_pl, #upload_myr {
    display: none;
}

#btn_upload_pl, #btn_upload_myr {
    display: inline-block;
    cursor : pointer;

    border : 1px solid black;
    padding: 0 3px;
    background-color: lightgray;
}

#txt_upload_pl, #txt_upload_myr {
    display: inline-block;
    padding-left : 5px;
}

.material-icons.icn_errorfile {
    color : #cc0b00;
    font-size: 20px;
    vertical-align: top;
    cursor: pointer;
    padding-left: 5px;
}

.support {
    color : grey;
}

.material-icons.icn_okfile {
    color : #00aa00;
    font-size: 20px;
    vertical-align: top;
    padding-left: 5px;
}

.infodl {
    margin-top:10px;
}

.txt_infodl {
    margin-bottom: 5px;
}

</style>
